var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotesEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 60,
    viewBox: "0 0 71 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 50.63C10.587 45.422 15.88 39.305 15.88 32.277c-4.513-.521-8.244-2.365-11.195-5.532C1.736 23.58.26 19.913.26 15.748c0-4.425 1.432-8.156 4.296-11.193C7.42 1.518 11.02 0 15.36 0c4.86 0 9.07 1.974 12.627 5.922 3.559 3.948 5.338 8.742 5.338 14.382 0 16.92-9.46 30.152-28.379 39.696L0 50.63zm37.364 0c10.674-5.207 16.011-11.324 16.011-18.352-4.6-.521-8.374-2.365-11.325-5.532-2.95-3.167-4.426-6.833-4.426-10.998 0-4.425 1.454-8.156 4.361-11.193C44.892 1.518 48.515 0 52.855 0c4.86 0 9.047 1.974 12.561 5.922 3.515 3.948 5.273 8.742 5.273 14.382 0 16.92-9.416 30.152-28.248 39.696l-5.077-9.37z",
    fill: "#FFDC66"
  })));
}
export default SvgQuotesEnd;